import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import socket from "../../socket";
import { pathHomePage } from "../../config/constants";
import { Popup, CallerText, ActionRow, AnswerBtn, RejectBtn } from "./styles";
import ringToneSrc from "../../assets/ring_tone.wav";

const CallNotification = () => {
  const [callData, setCallData] = useState(null);
  const locationRef = useRef(null);
  const ringToneRef = useRef(null);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => { locationRef.current = location; }, [location]);

  useEffect(() => {
    const ring = new Audio(ringToneSrc);
    ring.loop = true;
    ringToneRef.current = ring;
    return () => { ring.pause(); ring.currentTime = 0; };
  }, []);

  // Ring tone for notification popup
  useEffect(() => {
    const ring = ringToneRef.current;
    if (!ring) return;
    if (callData) {
      ring.currentTime = 0;
      ring.play().catch(() => {});
    } else {
      ring.pause();
      ring.currentTime = 0;
    }
  }, [callData]);

  useEffect(() => {
    const authenticate = () => {
      const token = localStorage.getItem("token");
      if (token) socket.emit("authenticate", token);
    };
    if (socket.connected) authenticate();
    socket.on("me", authenticate);

    const handleCall = (data) => {
      // Si el usuario está en Home, VideoCallComponent lo gestiona
      if (locationRef.current?.pathname === pathHomePage) return;
      if (!localStorage.getItem("token")) return;
      setCallData(data);
    };

    const clearCall = () => setCallData(null);

    socket.on("callUser", handleCall);
    socket.on("callEnded", clearCall);
    socket.on("callCancelled", clearCall);

    return () => {
      socket.off("me", authenticate);
      socket.off("callUser", handleCall);
      socket.off("callEnded", clearCall);
      socket.off("callCancelled", clearCall);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAnswer = () => {
    if (!callData) return;
    history.push(pathHomePage, { pendingAnswer: callData });
    setCallData(null);
  };

  const handleReject = () => {
    if (callData?.from) socket.emit("rejectCall", { to: callData.from });
    setCallData(null);
  };

  if (!callData) return null;

  return (
    <Popup>
      <CallerText>{callData.name || "Alguien"} está llamando...</CallerText>
      <ActionRow>
        <AnswerBtn onClick={handleAnswer}>Contestar</AnswerBtn>
        <RejectBtn onClick={handleReject}>Rechazar</RejectBtn>
      </ActionRow>
    </Popup>
  );
};

export default CallNotification;
